import React from 'react';
import { Card, CardBody } from './ui/card';
import { Skeleton } from './ui/skeleton';

export const CalendarSkeleton: React.FC = () => (
  <Card>
    <div className="flex items-center justify-between px-5 pt-5 pb-4">
      <div className="flex items-center gap-3">
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="h-4 w-28" />
      </div>
      <Skeleton className="h-9 w-48 rounded-lg" />
    </div>
    <CardBody>
      <div className="mb-2 grid grid-cols-7 gap-1.5">
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton key={i} className="mx-auto h-3 w-8" />
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1.5">
        {Array.from({ length: 35 }).map((_, i) => (
          <Skeleton key={i} className="h-16 rounded-lg sm:h-24 2xl:h-[8.75rem]" />
        ))}
      </div>
    </CardBody>
  </Card>
);

export const MonthlySummarySkeleton: React.FC = () => (
  <Card>
    <CardBody className="pt-5">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="mt-3 h-9 w-40" />
      <div className="mt-5 grid grid-cols-2 gap-2.5">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-[76px] rounded-xl" />
        ))}
      </div>
    </CardBody>
  </Card>
);

export const TimeEntryFormSkeleton: React.FC = () => (
  <div className="flex flex-col gap-3">
    <Skeleton className="h-28 rounded-xl" />
    <Skeleton className="h-28 rounded-xl" />
    <Skeleton className="h-12 rounded-xl" />
  </div>
);
